/*!
 * Developed by Markant
 */
class Config {
    get(key, fallback) {
        const value = this.storage && this.storage[key];
        return value !== null && value !== void 0 ? value : fallback;
    }
    patch(key, value) {
        if (this.storage && this.storage[key]) {
            this.storage[key] = value;
        }
    }
    get storage() {
        if (typeof window !== 'undefined') {
            const configWrapper = window.markantElements;
            if (configWrapper && configWrapper.config) {
                return configWrapper.config;
            }
        }
        return null;
    }
}
const config = new Config();
/**
 * Setups the config. Function to be called during intialization to set config / user preferences.
 *
 * @param config A given config
 */
const setupConfig = (config) => {
    const win = window;
    const namespace = win.markantElements;
    if (namespace && namespace.config && namespace.config.constructor.name !== 'Object') {
        console.error('markant elements config was already initialized');
        return;
    }
    win.markantElements = win.markantElements || {};
    win.markantElements.config = config;
};

export { config as c, setupConfig as s };
